// src/config/app.ts
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '@/App.vue';
import router from '@/router';
import i18n from '@/i18n';

// Import library CSS
import '@myorg/account-lib/style.css';
import '@myorg/menu-editor-lib/style.css';
import '@myorg/booking-lib/style.css';
import '../output.css';
import 'sweetalert2/dist/sweetalert2.min.css';

export function createAppInstance() {
  const app = createApp(App);
  const pinia = createPinia();

  app.use(pinia);
  app.use(i18n);
  
  return { app, pinia };
}
